import { createStore } from 'vuex'
import router from '../router'

const store = createStore({
  // 数据
  state: {
    tabsPage: [],
    tabsValue: ''
  },
  // 方法
  mutations: {
    editableTabs: (state, obj) => {
      // 标签页的默认首页
      if (obj === undefined) {
        var arr = []
        arr.push({
          id: 0,
          label: '首页',
          name: 'index',
          path: '/sys/index'
        })
        state.tabsPage = arr
        state.tabsValue = 'index'
        router.push({
          path: arr[0].path
        })
      } else {
        // console.log('obj=', obj)
        // 浅拷贝 state.tabsPage
        const arr = Array.from(state.tabsPage)
        // 使用 Array.some 去判断是否存在对象信息
        var exist = arr.some(item => item.path === obj.path)
        // even方法 如果对象存在返回true,不存在则返回flase
        // 如果不存在将对象push进数组内bing
        if (!exist && obj.path !== '') {
          // 将tabs所需参数push进arr数组
          arr.push({
            id: obj.id,
            label: obj.name,
            name: obj.code,
            path: obj.path,
            qx: obj.qx,
            closable: true
          })
          // 赋值给tabsPage参数
          state.tabsPage = arr
          // 存储sessionStorage -- 解决刷新消失
          // window.sessionStorage.setItem('tabsPage', JSON.stringify(arr))
          // window.sessionStorage.setItem('TabsValue', obj.routeName)
          // 赋值给TabsValue参数
          state.tabsValue = obj.code
          // 跳转
          router.push({
            path: obj.path,
            name: obj.code,
            params: { qx: obj.qx }
          })
        } else { // 如果存在 只做跳转选中
          // 赋值给TabsValue参数
          state.tabsValue = obj.code
          // window.sessionStorage.setItem('TabsValue', obj.routeName)
          // 跳转 params/query传参数,query是通过url传参，地址可见
          router.push({
            path: obj.path,
            name: obj.code,
            params: { qx: obj.qx }
          })
        }
      }
    }
  },
  // 执行mutations中的方法，异步操作actions
  actions: {
    editableTabs (context, obj) {
      context.commit('editableTabs', obj)
    }
  },
  modules: {
  }
})
export default store
